import pages from './pages';
import createNav from './create-nav';

export default {
  pages,
  createNav
};



// WEBPACK FOOTER //
// ./src/constants/index.js